import styled from 'styled-components';

const StickyWrapper = styled.div`
    position: fixed;
    bottom: 0;
    width: 100%;
    background: linear-gradient(to top,rgba(255, 255, 255, 1) 0%,rgba(255, 255, 255, 1) 75%,rgba(255, 255, 255, 0) 100%);
    padding-top: 84px;
    pointer-events: none;
    z-index: 1;
`;

const ChildrenWrapper = styled.div`
    width: 100%;
    pointer-events: auto;
`;

type TProps = {
    children?: React.ReactNode;
};

const StickyFooter = ({ children }: TProps) => {
    return (
        <StickyWrapper id="sticky-footer">
            {children ? <ChildrenWrapper>{children}</ChildrenWrapper> : null}
        </StickyWrapper>
    );
};

export default StickyFooter;
